export const isReportDownloadUrl = (value: unknown): value is string => {
  if (typeof value !== 'string' || !value.trim()) {
    return false;
  }
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) && /\.(pdf|xlsx|xls|csv|zip)$/i.test(url.pathname);
  } catch {
    return false;
  }
};

export const downloadReport = (report: {
  document_url: unknown;
  project: { name: string };
  application_no: string | number;
  file_extension: string;
}) => {
  if (!isReportDownloadUrl(report.document_url)) {
    return;
  }
  const link = document.createElement('a');
  link.href = report.document_url;
  const extension = new URL(report.document_url).pathname.split('.').pop();
  link.download = `${report.project.name}_${report.application_no}.${extension}`;
  link.click();
};
